/* @flow */
import _ from 'lodash';

export function getUniqueUsers(reactionsSummary: ReactionSummaryGQL): Object[] {
  const users = _.flatten(reactionsSummary.reactions.map(r => r.users));
  return _.unionBy(users, 'uuid');
}

export function userNamesReplacingYourNameWithYou(users: Object[], userUuid: string): string[] {
  return users.map(u => {
    return u.uuid === userUuid ? 'You' : u.name;
  });
}
